import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Receipt } from 'lucide-react';
import { formatDate } from '../../lib/constants';

const formatCurrency = (val) => `Rp ${Number(val || 0).toLocaleString('id-ID')}`;

const ExpensesCard = ({ expenses, canAddExpense, canDeleteExpense, canViewPrice, onAdd, onDelete, currentUserId, currentUserRole }) => {
  const total = expenses.reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0);
  return (
    <Card className="border-border">
      <CardHeader className="border-b border-border">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-lg tracking-tight font-medium flex items-center gap-2">
            <Receipt className="w-5 h-5" />
            Pembelian Langsung ({expenses.length})
          </CardTitle>
          {canAddExpense && (
            <Button size="sm" variant="outline" onClick={onAdd} data-testid="add-expense-button">
              + Tambah Pembelian
            </Button>
          )}
        </div>
        <p className="text-xs text-muted-foreground mt-1">
          Bill/nota pembelian yang sudah dibayar dulu tanpa Purchase Request. Nilainya akan otomatis masuk ke invoice akhir.
        </p>
      </CardHeader>
      <CardContent className="p-4">
        {expenses.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground">
            <Receipt className="w-10 h-10 mx-auto mb-2 opacity-30" />
            <p className="text-sm">Belum ada pembelian langsung</p>
          </div>
        ) : (
          <>
            <div className="space-y-2">
              {expenses.map((ex) => (
                <div key={ex.id}
                  className="flex items-start justify-between gap-3 p-3 rounded-md border border-border bg-secondary/30"
                  data-testid={`expense-row-${ex.id}`}>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium">{ex.description}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {ex.vendor ? `Vendor: ${ex.vendor} • ` : ''}
                      Oleh {ex.created_by_name || '-'} • {formatDate(ex.created_at)}
                    </p>
                    {ex.note && <p className="text-xs text-muted-foreground mt-1 italic">{ex.note}</p>}
                    {ex.receipt_url && (
                      <a
                        href={ex.receipt_url.startsWith('http') ? ex.receipt_url : `${process.env.REACT_APP_BACKEND_URL}${ex.receipt_url}`}
                        target="_blank" rel="noreferrer"
                        className="text-xs text-primary hover:underline mt-1 inline-block">
                        Lihat bukti pembelian →
                      </a>
                    )}
                  </div>
                  <div className="text-right">
                    {canViewPrice && (
                      <p className="text-sm font-semibold whitespace-nowrap">{formatCurrency(ex.amount)}</p>
                    )}
                    {canDeleteExpense && (ex.created_by === currentUserId || currentUserRole === 'super_admin') && (
                      <button type="button" onClick={() => onDelete(ex)}
                        className="text-xs text-destructive hover:underline mt-1"
                        data-testid={`delete-expense-${ex.id}`}>
                        Hapus
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {canViewPrice && (
              <div className="border-t border-border mt-3 pt-3 flex justify-between items-center">
                <span className="text-sm text-muted-foreground">Total Pembelian Langsung</span>
                <span className="text-base font-bold text-primary" data-testid="expenses-total">
                  {formatCurrency(total)}
                </span>
              </div>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default ExpensesCard;
